import { EventContext } from '@contexts/event';
import { createContextWithSelector } from '@utils';

export const useEventfy = createContextWithSelector(EventContext, 'useEventfy');
